// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"a14da3cc","418":"c71a2d54","816":"ee02ae78"}[chunkId] + ".js";
};